// extracted by mini-css-extract-plugin
export default {"Overlay":"Modal_Overlay__yoxbg","Content":"Modal_Content__0FhBb","Header":"Modal_Header__KcIfo","CloseButton":"Modal_CloseButton__ATdYL","Body":"Modal_Body__0hT+M"};